import DashboardIcon from "assets/svg/navigation/dashboard-icon.svg";
import UserIcon from "assets/svg/navigation/user-icon.svg";
import BusinessIcon from "assets/svg/navigation/business.svg";
import TransactionsIcon from "assets/svg/navigation/transactions-icon.svg";
import ComplianceIcon from "assets/svg/navigation/compliance-icon.svg";
// import CharityIcon from "assets/svg/navigation/charity-icon.svg";
import CurrencyIcon from "assets/svg/navigation/currency-icon.svg"; 
import ExchangeRatesIcon from "assets/svg/navigation/exchange-rates-icon.svg";
import BeneficiaryIcon from "assets/svg/navigation/beneficiary-icon.svg";
import { ROUTES } from "constants/routes";

export const navData: INavigationData[] = [
  {
    text: "Dashboard",
    icon: DashboardIcon,
    link: ROUTES.DASHBOARD.path,
  },
  {
    text: "Users",
    icon: UserIcon,
    link: ROUTES.USERS.path,
  },
  {
    text: "Businesses",
    icon: BusinessIcon,
    link: ROUTES.BUSINESSES.path,
  },
  {
    text: "Transactions",
    icon: TransactionsIcon,
    link: ROUTES.TRANSACTIONS.path,
  },
  {
    text: "Exchange Rates",
    icon: ExchangeRatesIcon,
    link: ROUTES.EXCHANGE_RATES.path,
  },
  {
    text: "Currencies",
    icon: CurrencyIcon,
    link: ROUTES.CURRENCIES.path,
  },
  {
    text: "Beneficiaries",
    icon: BeneficiaryIcon,
    link: ROUTES.BENEFICIARIES.path,
  },
  // Compliance disabled for now
  // {
  //   text: "Compliance",
  //   icon: ComplianceIcon,
  //   link: ROUTES.FLAGGED_USERS.path,
  // },
  // Charity disabled for now
  // {
  //   text: "Charity",
  //   icon: CharityIcon,
  //   link: ROUTES.CHARITY.path,
  // },
  {
    text: "Audit Trail",
    icon: ComplianceIcon,
    link: ROUTES.AUDIT_TRAIL.path,
  },
];
